module.exports = __webpack_public_path__ + "img/pubgm.3e3c9c4.png";